module.exports = __webpack_public_path__ + "img/202405_09.2b3ce9f0.jpg";